export default "__VITE_ASSET__NHx4pbh8__"